<template>
  <label
    class="transition duration-200 ease-in-out inline-flex items-center w-11 h-6 relative rounded-[48px] p-0.5 shrink-0"
    :class="[
      value ? 'bg-green' : 'border border-[#C8CFD666] bg-gray-350',
      disabled ? 'cursor-not-allowed' : 'cursor-pointer',
    ]"
    @click="onToggle"
  >
    <span
      class="absolute w-5 h-5 rounded-full transition duration-200 ease-in-out"
      :class="value ? 'translate-x-5 bg-white' : 'translate-x-0 bg-gray'"
    />
  </label>
</template>
<script setup lang="ts">
import { computed } from "vue";
interface Props {
  label?: string;
  modelValue: boolean;
  disabled?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  disabled: false,
});

interface Emits {
  (e: "update:modelValue", v: boolean): void;
}
const emit = defineEmits<Emits>();

const value = computed({
  get() {
    return props.modelValue;
  },
  set(val: boolean) {
    emit("update:modelValue", val);
  },
});

const onToggle = () => {
  if (!props?.disabled) {
    value.value = !value.value;
  }
};
</script>
